import { Card, Box, Typography } from "@mui/material";

import { FieldProps } from "@/core/components/Field";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { getBasicConfig } from "@/core/utils";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { REPLACEMENT_AMOUNT } from "@/core/types/types";

const ColumnCard = ({ field }: FieldProps) => {
  const fc = useFormContext();
  const locale = getBasicConfig({})?.language;
  const replacementAmount = fc.watch(REPLACEMENT_AMOUNT);

  const [amount, setAmount] = useState("0");

  const formatNumber = (num: number | undefined, locale?: string): string => {
    if (num === undefined) {
      return "0";
    }

    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };

  useEffect(() => {
    if (replacementAmount !== undefined) {
      const formattedAmount = formatNumber(replacementAmount, locale);
      setAmount(formattedAmount);
    }
  }, [replacementAmount, locale]);

  return fc.formState.isValid && Number(replacementAmount) > 0 ? (
    <Card sx={{ boxShadow: "none", padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{t(field.text)}</Typography>
        <Typography sx={{ textAlign: "right", whiteSpace: "nowrap", ml: 2 }}>
          {amount} {field.properties?.unitLabel}
        </Typography>
      </Box>
    </Card>
  ) : null;
};

export default ColumnCard;
